import { call, select, takeLatest } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { isExtremwetterUWProcessNecessary, selectFeatureToggle } from '@ps20-frontend/selector';
import { UwContext } from '@ps20-frontend/uw';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { Feature } from '@ps20/bff-models';
import { IAppState } from '../appState';
import {
  isUwProzessForNebengebaeudeNecessary,
  mapStateToPremiumAndExtremwetterDisabledSelectorTo,
} from '../../app/shared/selectors/produkt.selector';

export function* watchReevaluateUwRequirednessAfterLoad() {
  yield takeLatest(
    GlobalActions.SAVED_STATES_LOADED,
    safeSaga(reevaluateUwRequirednessAfterLoad, App.VWG_V2),
  );
}

export function* reevaluateUwRequirednessAfterLoad() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();

  const selectedProduktlinie = getSelectedProduktlinie(state.produkt);
  const hasWeitereNaturgefahren = Boolean(
    selectedProduktlinie?.zusatzoptionen.some(
      zusatzoption => zusatzoption.id === 'weitereNaturgefahren' && zusatzoption.isSelected,
    ),
  );

  const showElementarfragebogen = Boolean(
    hasWeitereNaturgefahren &&
      isExtremwetterUWProcessNecessary(mapStateToPremiumAndExtremwetterDisabledSelectorTo(state)),
  );
  const showNebengebaeude = Boolean(
    selectFeatureToggle(state, Feature.UW_NEBENGEBAEUDE) &&
      isUwProzessForNebengebaeudeNecessary(state, state.vertragsoptionen),
  );
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().setUnderwriterInfo(
      state.angebotsId,
      {
        [UwContext.NATURAL_HAZARDS]: showElementarfragebogen,
        [UwContext.OUTBUILDING]: showNebengebaeude,
      },
      true,
    ),
  );
}
